import { useEffect, useState } from "react";
import { useDataContext } from "../Context/dataContext";

const useWebSocket = () => {
  const { infoTkn } = useDataContext(); // Obtenemos el contexto de datos
  const [ws, setWs] = useState(null); // Estado para la conexión WebSocket
  const [messages, setMessages] = useState([]); // Estado para almacenar mensajes recibidos
  const [inputMessage, setInputMessage] = useState(""); // Estado para el mensaje a enviar

  useEffect(() => {
    if (!infoTkn) {
      console.error("No se encontró el token JWT");
      return;
    }

    // Creamos la conexión WebSocket
    const socket = new WebSocket("wss://ws.moneymoveroficial.com"); // Cambia la URL según tu entorno
    setWs(socket); // Guardamos la instancia en el estado
    // Evento: conexión abierta
    socket.onopen = () => {
      console.log("Conexión WebSocket establecida");
      console.log("Estado del WebSocket:", socket.readyState); // Debe ser 1 (OPEN)
      socket.send(JSON.stringify({ token: infoTkn }));
    };

    // Evento: mensaje recibido
    socket.onmessage = (event) => {
      const message = JSON.parse(event.data);
      console.log("Mensaje recibido del servidor:", message);

      if (message.action === "logout") {
        console.log("Logout detectado desde WebSocket");
        const logoutEvent = new CustomEvent("logout");
        window.dispatchEvent(logoutEvent);
      }

      // Actualizamos el estado con el mensaje recibido
      setMessages((prevMessages) => [...prevMessages, message]);
    };

    // Evento: conexión cerrada
    socket.onclose = () => {
      console.log("Conexión WebSocket cerrada");
    };

    // Evento: error en la conexión
    socket.onerror = (error) => {
      console.error("Error en la conexión WebSocket:", error.message || error);
      console.error("Detalles del WebSocket:", socket);
    };

    // Cleanup: cerramos la conexión WebSocket al desmontar el componente
    return () => {
      socket.close();
    };
  }, [infoTkn]);

  // Función para enviar un mensaje al servidor
  const sendMessage = () => {
    if (ws && ws.readyState === WebSocket.OPEN) {
      ws.send(JSON.stringify({ action: "message", content: inputMessage }));
      setInputMessage(""); // Limpiar el campo de entrada
    } else {
      console.error("La conexión WebSocket no está abierta");
    }
  };

  return (
    <div>
      <h1>WebSocket Client</h1>
      <div>
        <h2>Mensajes recibidos:</h2>
        <ul>
          {messages.map((msg, index) => (
            <li key={index}>{JSON.stringify(msg)}</li>
          ))}
        </ul>
      </div>
      <div>
        <input
          type="text"
          value={inputMessage}
          onChange={(e) => setInputMessage(e.target.value)}
          placeholder="Escribe un mensaje"
        />
        <button onClick={sendMessage}>Enviar</button>
      </div>
    </div>
  );
};

export { useWebSocket };
